// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1PfEu","header":"ReportDetails_header__2f8GE","title":"ReportDetails_title__JihFZ","left":"ReportDetails_left__3RI9L"};